'use client';

import React from 'react';

import { Button } from '@ui/button';
import { Media } from '@/components/Media';
import { CMSLink } from '@/components/Link';
import { Svg } from '@ui/svg';
import { NAV } from '@/constants';
import type { Service } from '@/payload-types';

export const ServiceList: React.FC<{
  services: Service[];
}> = ({ services }) => {
  return (
    <section className="v-margin !mt-0" data-name="ServiceList">
      <div className="container">
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-1 lg:gap-7">
          {services.map((doc) => {
            const title = doc.titleInList || doc.title;

            return (
              <CMSLink
                className="group flex items-center"
                url={NAV.serviceDetail(doc.slug!)}
                key={doc.id}
              >
                <div className="z-10 w-full max-w-[209px] md:max-w-[132px]">
                  <h3 className="md:tracking-0 relative mb-8 text-[40px] leading-[48px] font-semibold tracking-[-0.03em] md:mb-[18px] md:text-[16px] md:leading-[24px]">
                    <div className="w-fit rounded-[24px] bg-[#FAFAFA] pt-2.5 pr-[23px] pb-3 md:rounded-[12px] md:p-1 md:pr-3">
                      {title}
                    </div>
                    <Svg
                      className="absolute bottom-full left-full md:hidden"
                      id="corner"
                    />
                    <Svg
                      className="absolute top-full left-full rotate-90 md:hidden"
                      id="corner"
                    />
                  </h3>
                  <Button className="group-hover:ring-blue/50" size="sm">
                    Подробнее
                  </Button>
                </div>
                <div className="relative aspect-[584/376] w-full max-w-[584px] md:max-w-full">
                  <Media imgClassName="corners" resource={doc.image} fill />
                </div>
              </CMSLink>
            );
          })}
        </div>
      </div>
    </section>
  );
};
